import type { TFunction } from "i18next";
import type { U2000DeleteHandlersReturn } from "../../../u2000Core/hooks/handler/U2000UseDeleteHandlers";
import U2000DeleteRecordDialog from "../../../u2000Core/components/dialog/U2000DeleteRecordDialog";

// Typage des props du composant
interface U3101EmployeeDeleteDlgProps {
  handleDelete: U2000DeleteHandlersReturn;
  t: TFunction;
  NS: string;
}

function U3101EmployeeDeleteDlg({ handleDelete, t, NS }: U3101EmployeeDeleteDlgProps) {
  if (!handleDelete.isDialogDeleteOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={handleDelete.isDialogDeleteOpen} onClose={handleDelete.handleDeleteCloseDlg} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">
        {t("msgDeleteEmployee", {
          count: handleDelete.selectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {handleDelete.selectedRows().map((row, index, array) => (
          <span key={row.codeEmployee} className="inline-block text-gray-800">
            {`${row.codeEmployee} - ${row.firstName} ${row.lastName}`}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3101EmployeeDeleteDlg;
